export const ALPHA_SIGNUP_FORM_URL =
  process.env.REACT_APP_ALPHA_SIGNUP_FORM_URL ||
  'https://docs.google.com/forms/d/e/1FAIpQLSdYodU1NCfBISSozdr_hUUyeSMx4PdCO17q9ld7y7FDinGhYg/viewform?usp=dialog';

export const FEEDBACK_FORM_URL =
  process.env.REACT_APP_FEEDBACK_FORM_URL ||
  'https://docs.google.com/forms/d/e/1FAIpQLSdYodU1NCfBISSozdr_hUUyeSMx4PdCO17q9ld7y7FDinGhYg/viewform?usp=dialog';
